import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TravelHistory } from 'src/app/models/localization/travel-history';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  ExportDataService,
  FunctionsService,
  HeaderFilters,
  HttpService,
  MenuBreadCrumb,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';

@Component({
    selector: 'app-travel-history',
    templateUrl: './travel-history.component.html',
    styleUrls: ['./travel-history.component.scss'],
    standalone: false
})
export class TravelHistoryComponent implements OnInit {
  public travelHistoryId: number = 0;
  public selected = new UntypedFormControl(0);
  public EndpointDictionary = EndpointDictionary;
  public xslxParams: params[] = [{id:'includeCheckpoints', value:true}]
  public reloadhistoryTravelTable = new EventEmitter<any>();
  public historyTravelColumnsTable: TableColumns<TravelHistory>[] = [
    {
      ID: 'routeName',
      label: 'Nombre ruta',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'code',
      label: 'Nombre equipo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'userName',
      label: 'Realizó',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'startDate',
      label: 'Fecha inicio',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'endDate',
      label: 'Fecha fin',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'numberCheckPoint',
      label: 'Puntos verificados',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  public headerFileTableXlsm: Array<params> = [
    { id: 'name', value: 'Nombre' },
    { id: 'longitude', value: 'Longitud' },
    { id: 'latitude', value: 'Latitud' },
    { id: 'date', value: 'Fecha' },
    { id: 'registered', value: 'Punto registrado' },
    {id: 'description', value: 'Comentario' },
    {id: 'additionalCheckpoint', value: 'Punto control adicional' },
    {id:null, value:"Equipo : {code}"},
    {id:null, value:"Realizado por : {userName}"},
    {id:null, value:"Fecha y hora inicio : {startDate}"},
    {id:null, value:"Fecha y hora final : {endDate}"},
    {id:null, value:"Distancia total en Km : {distance}"},
    {id:null, value:"Tiempo del recorrido en horas : {timeHours}"}
    
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'rutas',
      labelFilter: 'Ruta',
      urlData: EndpointDictionary.TravelRoute.TRAVEL_ROUTER_COMBO,
      visibleField: 'name',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: EndpointDictionary.Equipment.EQUIPMENT_COMBO,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'historico_viajes',
      labelFilter: 'Realizo',
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'creada_por',
    },
    {
      tN: 'historico_viajes',
      labelFilter: 'Fecha Inicio',
      visibleField: 'fecha_inicio',
      type: 'date',
      value: '',
    },
    {
      tN: 'historico_viajes',
      labelFilter: 'Fecha Fin',
      visibleField: 'fecha_fin',
      type: 'date',
      value: '',
    },
    {
      tN: 'historico_viajes',
      labelFilter: 'Fecha Inicio Entre',
      visibleField: 'fecha_inicio',
      type: 'dateRange',
      value: '',
    },
    {
      tN: 'historico_viajes',
      labelFilter: 'Fecha Fin Entre',
      visibleField: 'fecha_fin',
      type: 'dateRange',
      value: '',
    },
  ];

  public historyTravelConfigurationTable: TableConfiguration = {
    primaryKey: 'id',
    view: true,
    selectable: false,
    exportXslxWithPages:true,
  };

  menuBreadCrumb: MenuBreadCrumb[] = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Historial viajes',
      current: true,
    },
  ];

  constructor(
    private http: HttpService,  
    private exportData: ExportDataService,
    private functionEter: FunctionsService,
  ) {}

  ngOnInit(): void {}

  async viewDetail($event: TravelHistory[]) {
    this.travelHistoryId = $event[0].id;
    this.selected.setValue(1);
  }

}
